import { createNamedContext } from '@core/createNamedContext'

export type SnowplowContextContextValue = {
  defaultPropertyValue: string
}

export const SnowplowContext = createNamedContext<SnowplowContextContextValue>(
  'SnowplowContext',
  {
    defaultPropertyValue: 'default',
  }
)
